import React from 'react';

import {
  ThemeProvider as MuiThemeProvider,
  CssBaseline,
  ThemeOptions,
} from '@mui/material';

import {DefaultTheme} from '@mui/system';
import createResponsiveTheme from '@jobseeker/lotus/helpers/createResponsiveTheme';
import {defaultTheme} from '@jobseeker/lotus/theme';

import {mergeDeep} from '@jobseeker/common-core/utils';

type ThemeProviderProp = {
  children?: React.ReactNode;
  theme: DefaultTheme;
};

const getMergedTheme = (theme: Partial<ThemeOptions>) => {
  const mergedTheme = Object.freeze(mergeDeep({}, defaultTheme, theme));
  return createResponsiveTheme(mergedTheme);
};
const ThemeProvider = (props: ThemeProviderProp) => {
  const {children, theme} = props;
  const themeTemplate = getMergedTheme(theme);

  return (
    <MuiThemeProvider theme={themeTemplate}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
